import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import hero from "@/assets/tour-cambodia-10day-treeroots.jpg";

const itinerary = [
  { key: "01", label: "Day 1", time: "7:30 AM – 5:30 PM", title: "Angkor Wat, Angkor Thom, Bayon & Ta Prohm", body: "Begin in Siem Reap with the icons of Angkor sunrise at Angkor Wat, the south gate of Angkor Thom, the faces of the Bayon and the tree-clad ruins of Ta Prohm. Overnight: 4★ hotel in Siem Reap." },
  { key: "02", label: "Day 2", time: "8:00 AM – 5:30 PM", title: "Banteay Srei, Preah Khan, Neak Pean & Ta Som", body: "The pink sandstone carvings of Banteay Srei, then the Grand Circuit Preah Khan, Neak Pean and Ta Som. Overnight: Siem Reap." },
  { key: "03", label: "Day 3", time: "8:00 AM – 2:00 PM", title: "Kampong Phluk Floating Village", body: "Boat trip to Kampong Phluk on Tonlé Sap stilt houses, flooded forest and daily life on the lake. Overnight: Siem Reap." },
  { key: "04", label: "Day 4", time: "7:30 AM – 5:30 PM", title: "Phnom Kulen National Park", body: "1000 Lingas riverbed, the reclining Buddha and the waterfall of Phnom Kulen. Overnight: Siem Reap." },
  { key: "05", label: "Day 5", time: "7:30 AM – 6:30 PM", title: "Beng Mealea & Koh Ker", body: "The jungle-swallowed ruin of Beng Mealea and the seven-tiered pyramid of Koh Ker. Overnight: Siem Reap." },
  { key: "06", label: "Day 6", time: "6:30 AM – 3:00 PM", title: "Prek Toal Bird Sanctuary", body: "Early boat to Prek Toal one of Southeast Asia's most important waterbird colonies. Overnight: Siem Reap." },
  { key: "07", label: "Day 7", time: "7:30 AM – 5:30 PM", title: "Spean Toap & Banteay Chhmar", body: "Drive west via the ancient Angkor bridge of Spean Toap to remote Banteay Chhmar. Overnight: homestay / eco-lodge." },
  { key: "08", label: "Day 8", time: "Full Day", title: "Banteay Chhmar Temples & Village Life", body: "A full day exploring the moated city of Banteay Chhmar and its surrounding villages. Overnight: same location." },
  { key: "09", label: "Day 9", time: "8:00 AM – 6:00 PM", title: "Transfer to Battambang", body: "Transfer to Battambang via countryside and local villages. Overnight: 4★ hotel in Battambang." },
  { key: "10", label: "Day 10", time: "7:30 AM – 4:00 PM", title: "Transfer to Kampong Cham", body: "Drive to Kampong Cham the bamboo bridge and Mekong riverside. Overnight: hotel in Kampong Cham." },
  { key: "11", label: "Day 11", time: "Morning + Afternoon", title: "Kampong Cham → Kratie", body: "Local temples and villages in the morning, then transfer to Kratie. Overnight: riverside hotel in Kratie." },
  { key: "12", label: "Day 12", time: "7:30 AM – 2:00 PM", title: "Mekong Islands & Irrawaddy Dolphins", body: "Boat trip on the Mekong to spot the rare Irrawaddy dolphins and visit nearby islands. Overnight: Kratie." },
  { key: "13", label: "Day 13", time: "7:30 AM – 4:00 PM", title: "Transfer to Kampot", body: "Long but scenic transfer south to the riverside town of Kampot. Overnight: boutique hotel in Kampot." },
  { key: "14", label: "Day 14", time: "Full Day", title: "Pepper Farms, Countryside & River Cruise", body: "Visit Kampot's famous pepper farms, explore the countryside and finish with a sunset river cruise. Overnight: Kampot." },
  { key: "15", label: "Day 15", time: "Free Day", title: "Free Day  Optional Bokor Mountain", body: "A free day to relax, or take an optional excursion up Bokor Mountain. Overnight: Kampot." },
  { key: "16", label: "Day 16", time: "7:30 AM – 12:30 PM", title: "Transfer to Phnom Penh", body: "Transfer to the capital, Phnom Penh. Overnight: 4–5★ hotel in Phnom Penh." },
  { key: "17", label: "Day 17", time: "8:00 AM – 5:00 PM", title: "Royal Palace, Silver Pagoda, National Museum & Killing Fields", body: "A full day of Phnom Penh's essentials — the Royal Palace and Silver Pagoda, the National Museum and a sober afternoon at the Killing Fields. Overnight: Phnom Penh." },
  { key: "18", label: "Day 18", time: "Flexible", title: "Free Time & Airport Transfer", body: "Free morning, then transfer to Phnom Penh International Airport for your onward flight." },
];

const Timeline = ({ items }: { items: typeof itinerary }) => (
  <ol className="space-y-px">
    {items.map((s, idx) => (
      <li
        key={s.key}
        className="group grid grid-cols-1 md:grid-cols-[200px_1fr] gap-y-4 gap-x-6 md:gap-x-12 border-t border-border py-8 md:py-10 transition-colors hover:bg-secondary/40 last:border-b"
      >
        <div className="flex flex-wrap md:flex-col items-baseline md:items-start gap-x-3 gap-y-2 text-base">
          <span className="font-display text-primary tabular-nums text-xl">
            {String(idx + 1).padStart(2, "0")}
          </span>
          <span className="uppercase tracking-[0.2em] md:tracking-[0.3em] text-primary text-sm md:text-base">
            {s.time}
          </span>
        </div>
        <div>
          <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3 transition-colors group-hover:text-primary">
            {s.title}
          </h3>
          <p className="text-muted-foreground font-light leading-relaxed text-lg max-w-2xl">
            {s.body}
          </p>
        </div>
      </li>
    ))}
  </ol>
);

const optionOne = {
  label: "OPTION 1STANDARD PRIVATE TOUR",
  pricePrivate: "$1,915 – $2,300 total (1–2 pax)",
  priceGroup: "$900 – $1,300 per person",
  includes: [
    "Private air-conditioned transport",
    "Driver",
    "Hotel pickup & drop-off",
    "Drinking water",
  ],
  excludes: [
    "Hotels & accommodation",
    "Entrance fees",
    "Meals",
    "Tour guide",
  ],
};

const optionTwo = {
  label: "OPTION 2 ALL-INCLUSIVE",
  pricePrivate: "$3,700 – $4,800 total (1–2 pax)",
  priceGroup: "Extra person: +$1,200 – $1,600",
  includes: [
    "Private vehicle",
    "Professional English-speaking guide",
    "4–5★ hotels (17 nights)",
    "Daily breakfast and lunch",
    "All entrance fees",
    "Private boat tours",
    "Airport transfers",
    "Cold towels & drinking water",
  ],
  excludes: ["Dinner", "Personal expenses", "Travel insurance"],
};

const TourCambodia18Day = () => {
  const [option, setOption] = useState(0);
  const opt = option === 0 ? optionOne : optionTwo;
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={hero}
          alt="Cambodia private tour with French-speaking guide among the giant tree roots of Ta Prohm temple, Angkor"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Eighteen Day Grand Discovery</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              18 Days Across <em className="font-light">Cambodia</em>&nbsp;Siem Reap, Banteay Chhmar, Battambang, Kampong Cham, Kratie, Kampot &amp; Phnom Penh.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              Explore Cambodia in depth on this 18-day journey featuring the temples of Angkor Wat, floating villages, birdlife at Prek Toal Bird Sanctuary, remote heritage sites, Mekong towns, and coastal relaxation in Kampot, ending in Phnom Penh.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · 18 Days</span>
              <span>Group · 1–15</span>
              <span>From $1,915 / pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* QUICK NAV */}
      <nav aria-label="Section navigation" className="sticky top-0 z-30 bg-background/95 backdrop-blur border-b border-border">
        <div className="container max-w-6xl overflow-x-auto">
          <ul className="flex gap-6 md:gap-10 py-3 text-[11px] uppercase tracking-[0.3em] whitespace-nowrap">
            <li><a href="#intro" className="hover:text-primary transition-colors">Overview</a></li>
            <li><a href="#itinerary" className="hover:text-primary transition-colors">Itinerary</a></li>
            <li><a href="#pricing" className="hover:text-primary transition-colors">Pricing</a></li>
            <li><a href="#bring" className="hover:text-primary transition-colors">What to Bring</a></li>
            <li><a href="#good-to-know" className="hover:text-primary transition-colors">Good to Know</a></li>
            <li><a href="#book" className="hover:text-primary transition-colors">Book</a></li>
          </ul>
        </div>
      </nav>

      {/* INTRO */}
      <section id="intro" className="py-24 md:py-32 scroll-mt-20">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— The Idea</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-10 text-balance">
            Seven chapters of Cambodia, eighteen unhurried days.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Six days at Angkor and Tonlé Sap, west to the moated city of Banteay Chhmar, slow days in Battambang, the Mekong towns of Kampong Cham and Kratie with their Irrawaddy dolphins, then south to the pepper coast of Kampot before finishing in Phnom Penh the Royal Palace, the Silver Pagoda and a sober afternoon at the Killing Fields.
            </p>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section id="itinerary" className="pb-24 md:pb-32 scroll-mt-20">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Itinerary</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            Eighteen days, day by day.
          </h2>
          <Timeline items={itinerary} />
        </div><BookingSidebar pricePerPerson={1915} tourTitle="18 Days Tour Across Cambodia" pricingTiers={[{ maxPax: 2, price: 1915 }, { maxPax: 6, price: 2350 }, { maxPax: 10, price: 2789 }]} /></div></div>
      </section>

      {/* PRICING TABS */}
      <section id="pricing" className="bg-secondary py-24 md:py-32 scroll-mt-20">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Pricing &amp; Inclusions</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-12 text-balance">
            Choose your level of comfort.
          </h2>

          <div role="tablist" aria-label="Pricing options" className="flex flex-wrap justify-center gap-10 md:gap-16 mb-16">
            {[optionOne, optionTwo].map((o, i) => {
              const isActive = i === option;
              return (
                <button
                  key={o.label}
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setOption(i)}
                  className={`relative pb-3 uppercase tracking-[0.3em] transition-colors text-base ${
                    isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {o.label}
                  <span
                    className={`absolute left-0 right-0 -bottom-px h-px transition-colors ${
                      isActive ? "bg-primary" : "bg-transparent"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          <ul className="mb-12 space-y-4 font-light text-lg max-w-3xl mx-auto">
            <li className="border-b border-border pb-4 flex justify-between gap-6"><span>Private Tour (18 Days)</span><span className="text-right">{opt.pricePrivate}</span></li>
            <li className="pb-4 flex justify-between gap-6"><span>{option === 0 ? "Group Tour" : "Extra Person"}</span><span className="text-right">{opt.priceGroup}</span></li>
          </ul>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-12">
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Includes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.includes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Excludes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.excludes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section id="bring" className="py-24 md:py-32 scroll-mt-20">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Modest clothing shoulders &amp; knees covered</li>
                <li>Comfortable walking shoes</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for breakfast</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section id="good-to-know" className="bg-secondary py-24 md:py-32 scroll-mt-20">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>Sunrise tours are the most popular and tend to sell out quickly, especially during the dry season (November to March). We recommend booking at least 48 hours in advance during peak season, even earlier.</p>
            <p>Pickup time: 7:30 – 8:00 AM (exact time confirmed one day before).</p>
            <p>Dress code: casual but respectful covered shoulders and knees required inside temples. Comfortable walking shoes are strongly recommended.</p>
            <p>For safety, leave valuables at your hotel and bring only what you need. This tour is not wheelchair accessible. Children under 5 are not permitted. Maximum group size: 1–15 travellers in an air-conditioned vehicle.</p>
            <p><span className="text-foreground">Weather.</span> Hot and dry weather is expected throughout this tour. There is always the possibility of a shower or two, but it is likely to be dry most of the time. Midday temperatures are likely to be very hot, but most of the woodland sites we visit have low humidity.</p>
            <p><span className="text-foreground">Food.</span> Khmer cuisine is similar to most Southeast Asian cooking, but rather less spicy. Good bread is available in many areas thanks to the French influence, and there is a surprisingly wide range of local brews to try.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="book" className="py-24 md:py-32 scroll-mt-20">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Journey</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            Eighteen days. From Angkor to the Mekong to the coast.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourCambodia18Day;
